/* eslint-disable react/jsx-no-undef */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TopLogo from '../../components/layout/TopLogo';
import { useLiff } from "react-liff";
import dayjs from "dayjs";
import coupon2 from '../../assets/images/coupon2.png';
import SecondaryButton from "../../components/button/SecondaryButton";
import PrimaryButton from "../../components/button/PrimaryButton";
import Stack from "@mui/material/Stack";
import { useDispatch, useSelector } from 'react-redux';
import { SearchCouponOnlineById } from "../../services/Coupon";
import { setMember } from "../../features/MemberSlice"
import helper from "../../functions/helper";
import LightBlueButton from "../../components/button/LightBlueButton";


export default function MemberCouponOnlineDetail() {

    const { liff } = useLiff();
    const lineId = liff.getDecodedIDToken().sub;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const store = useSelector((state) => state.member)
    const [page, setPage] = React.useState("info");
    const [couponDetail, setCouponDetail] = React.useState(null);
    const [isCollect, setIsCollect] = React.useState(store['isView'])

    React.useEffect(() => {
        getSearchCouponOnlineById()
    }, []);

    async function getSearchCouponOnlineById() {
        return await SearchCouponOnlineById(store['couponId'])
            .then(async (response) => {
                if (+response.data.resultCode === 20000) {
                    let data = response.data.body
                    if (data.discountType === 'Fix') {
                        data.discountText = `฿${helper.numberWithCommas(data.discount)} | ขั้นต่ำ ฿${helper.numberWithCommas(data.min)}`
                    } else {
                        data.discountText = `${helper.numberWithCommas(data.discount)}% | ขั้นต่ำ ฿${helper.numberWithCommas(data.min)}`
                    }
                    setCouponDetail(data)
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    return (
        <>
            <TopLogo />
            {couponDetail &&
                <div
                    style={{
                        background: "#005AAA",
                        paddingTop: "20px"
                    }}
                >
                    <div className="text-white text-center text-[20px] my-[15px]">
                       รายละเอียด
                    </div>

                    <div className="overflow-y-auto px-[20px]" style={{ height: "calc(100vh - 240px)" }}>
                        {/* <InfiniteScroll
                        loadMore={fetchItems}
                        hasMore={isLoading}
                        loader={loader}
                    > */}
                        <div id="section1" className="px-[10px] py-[15px] bg-lightGray2 mb-[20px] rounded-[6px]">

                            <div className="text-center">
                                <p className="text-blue text-[24px] leading-[24px]">{couponDetail.name}</p>
                                {/* <p className="text-darkGray text-[20px]">ส่วนลด {helper.numberWithCommas(couponDetail.discountText)}</p> */}
                                <p className="text-darkGray text-[20px] leading-[18px]">ใช้คูปองได้ถึง {dayjs(couponDetail.expireDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}</p>

                            </div>

                            <hr className="border-b-1px border-lightGray w-full mt-[10px] mb-[20px]" />

                            {couponDetail.picture ? (
                                <img
                                    className="mx-auto mt-[10px]"
                                    src={couponDetail.picture}
                                    alt="logo"
                                    style={{ width: "208px" }}
                                />
                            ) : (
                                <img
                                    className="mx-auto mt-[10px]"
                                    src={coupon2}
                                    alt="logo"
                                    style={{ width: "208px" }}
                                />
                            )
                            }


                            <div className="flex items-center">
                                <p
                                    onClick={() => setPage("info")}
                                    className={
                                        `w-full text-[20px] text-gray text-center py-[9px] border-b-[1px] border-lightGray ` +
                                        (page === "info" && "!text-blue !border-b-[4px] !border-blue")
                                    }
                                >  รายละเอียด
                                </p>
                                <p
                                    onClick={() => setPage("condition")}
                                    className={
                                        `w-full text-[20px] text-gray text-center py-[9px] border-b-[1px] border-lightGray ` +
                                        (page === "condition" &&
                                            "!text-blue !border-b-[4px] !border-blue")
                                    }
                                >
                                    เงื่อนไข
                                </p>
                                <p
                                    onClick={() => setPage("branch")}
                                    className={
                                        `w-full text-[20px] text-gray text-center py-[9px] border-b-[1px] border-lightGray ` +
                                        (page === "branch" &&
                                            "!text-blue !border-b-[4px] !border-blue")
                                    }
                                >
                                    สาขาที่ร่วม
                                </p>
                            </div>

                            {page === "info" ? (
                                <div className="whitespace-pre-line mx-[15px] mt-[20px]">
                                    {couponDetail.detail}
                                </div>
                            ) : page === "condition" ? (
                                <div className="whitespace-pre-line mx-[15px] mt-[20px]">
                                    {couponDetail.conditions}
                                </div>
                            ) : (
                                <div className="mx-[15px] mt-[20px]">
                                    {Array.isArray(couponDetail.participatingList) && couponDetail.participatingList.length > 0 && couponDetail.participatingList.map((item, index) => (
                                        <div key={index}>
                                            <p>- {item}</p>
                                        </div>
                                    ))}
                                </div>
                            )}

                            <br></br>
                        </div>

                    </div>
                </div>}
            <div className="bg-white h-[100px] pt-[25px]">

                <Stack
                    spacing={2}
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                >
                    <SecondaryButton variant="outlined" className="w-[40%]" onClick={() => navigate(-1)}>
                        ยกเลิก
                    </SecondaryButton>
                    <PrimaryButton variant="contained" className="w-[40%]" onClick={() => liff.openWindow({ url: couponDetail.link, external: false })}>
                        ยืนยันใช้คูปอง
                    </PrimaryButton>
                </Stack>


            </div>
        </>
    );
}
